const servicesData = [
  {
    title: "Ku-Nye Services",
    subServices: [
      {
        title: "Himalayan tsampa Detoxification Ku Nye",
        category: "Whole Body Ku Nye Massage",
        benefits:
          "tsampa (Roasted barley flour) powder is used to get rid of toxins with Ku Nye therapy. It is a detoxifying & cleansing treatment.",
        duration: "120 minutes",
        price: "Nu.3,000",
      },
      {
        title: "Therapeutic Ku Nye",
        category: "Whole Body Ku Nye Massage",
        benefits:
          "Rejuvenating treatment where the specific points are stimulated to facilitate the flow of energy (chi).",
        duration: "90 minutes",
        price: "Nu.2,500",
      },
      {
        title: "Relaxation Ku Nye",
        category: "Whole Body Ku Nye Massage",
        benefits:
          "Harmonizes & stimulates the flow of energy, releases tension in the muscle & relaxes tired bodies.",
        duration: "60 minutes",
        price: "Nu.2,000",
      },
      {
        title: "Lower & Upper Limb Ku Nye",
        category: "Whole Body Ku Nye Massage",
        benefits:
          "Works on specific points to relieve tired muscles & tendons. Focuses on chronic pain and post-surgery rehabilitation.",
        duration: "40 minutes",
        price: "Nu.1,500",
      },
      {
        title: "Facial Massage",
        category: "Head, Face and Foot Massage",
        benefits: "Focuses on facial points.",
        duration: "40 minutes",
        price: "Nu.1,500",
      },
      {
        title: "Head Massage with Hot Oil",
        category: "Head, Face and Foot Massage",
        benefits:
          "It clears calms the mind, gives better circulation to your scalp for healthier hair growth. (Head Wash: additional Nu.150)",
        duration: "40 minutes",
        price: "Nu.1,000",
      },
      {
        title: "Foot Massage (Zhab Nye)",
        category: "Head, Face and Foot Massage",
        benefits: "It loosens & relaxes sore & tight muscles.",
        duration: "40 minutes",
        price: "Nu.1,000",
      },
      {
        title: "Pedicure",
        category: "Head, Face and Foot Massage",
        benefits: "Exfoliate the dead cells.",
        duration: "40 minutes",
        price: "Nu.1,500",
      },
      {
        title: "Herbal Foot Steam Bath",
        category: "Herbal Steam (Amrita's)",
        benefits:
          "Distributes medicine through skin, points and channels to directly reach the location of disease. The medicine works faster than the oral medicine.",
        duration: "30 minutes",
        price: "Nu.500",
      },
      {
        title: "Five Nectar Herbal Steam",
        category: "Herbal Steam (Amrita's)",
        benefits:
          "Rejuvenates the body, stimulates blood circulation, expels dampness, heat & phlegm, eliminates toxins, internal organs benefits, strengthens the lower back & improves flexibility.",
        duration: "30 minutes",
        price: "Nu.750",
      },
      {
        title: "Herbal Bath (Wooden Tub)",
        category: "Herbal Steam (Amrita's)",
        benefits:
          "Reliefs to sport injuries, muscles pain and arthritis. Helps in losing weight.",
        duration: "60 minutes",
        price: "Nu.1,200",
      },
    ],
  },
  {
    title: "Salon Services",
    subServices: [
      {
        title: "Hair Wash",
        category: "Hair Care",
        duration: "15 minutes",
        price: "Nu.250 - Nu.350",
      },
      {
        title: "Hair Color",
        category: "Hair Care",
        duration: "60 minutes",
        price: "Nu.600 - Nu.1500",
      },
      {
        title: "Hair Cut and Trimming",
        category: "Hair Care",
        duration: "15 minutes",
        price: "Nu.200 - Nu.350",
      },
      {
        title: "Hair SPA",
        category: "Hair Care",
        duration: "60 minutes",
        price: "Nu.1200 - Nu.1500",
      },
      {
        title: "Hair Oiling",
        category: "Hair Care",
        duration: "40 minutes",
        price: "Nu.600",
      },
      {
        title: "Hair Set",
        category: "Hair Care",
        duration: "15 minutes",
        price: "Nu.200",
      },
      {
        title: "Facial",
        category: "Face and Brows",
        duration: "40-60 minutes",
        price: "Nu.600 - Nu.1500",
      },
      {
        title: "Threading",
        category: "Face and Brows",
        duration: "N/A",
        price: "Nu.40",
      },
      {
        title: "Upper Lip",
        category: "Face and Brows",
        duration: "N/A",
        price: "Nu.40",
      },
      {
        title: "Waxing ArmPits",
        category: "Waxing",
        duration: "15 minutes",
        price: "Nu.400",
      },
      {
        title: "Waxing Arm and Leg (Full)",
        category: "Waxing",
        duration: "60 minutes",
        price: "Nu.1200 - Nu.1500",
      },
      {
        title: "Pedicure",
        category: "Hands and Feet",
        duration: "40-60 minutes",
        price: "Nu.600 - Nu.1200",
      },
      {
        title: "Manicure",
        category: "Hands and Feet",
        duration: "40-60 minutes",
        price: "Nu.600 - Nu.1000",
      },
      {
        title: "Gel Polish",
        category: "Hands and Feet",
        duration: "60 minutes",
        price: "Nu.1000",
      },
      {
        title: "Nail Extension",
        category: "Hands and Feet",
        duration: "60 minutes",
        price: "Nu.1500 - Nu.2000",
      },
    ],
  },
];

export default servicesData;
